import { h } from 'preact';

const MaxOrderMessage = ({ maxOrder, errorMessage, quantity }) =>
  quantity >= maxOrder && (
    <p className="text-[.8125rem] tracking-[.13px] leading-5 text-orange-1 mt-2">{errorMessage}</p>
  );

export default MaxOrderMessage;
